module.exports = __webpack_public_path__ + "img/comofunciona_icone_1.1.91096e38.webp";